import React, { useEffect, useState } from 'react'
import "./navbar.css"
import { IoIosArrowForward } from "react-icons/io";
import { IoCloseSharp } from "react-icons/io5";
import { FaArrowRight } from "react-icons/fa";

const Nav = () => {

    const [collectionMenu, setCollectionMenu] = useState('collection')
    const [scroll, setScroll] = useState(false)
    const [navSelect, setNavSelect] = useState(false)
    const [navOpen, setNavOpen] = useState(false)

    const handleOpenNav = () => {
        setNavOpen(true);
    };
    
    const handleCloseNav = () => {
        setNavOpen(false);
    };

    const handleNavChange = () => {
        if(!navSelect === true){
            setNavSelect(true)
        }else{
            setNavSelect(false)
        }
    }

    const handleMouseEnter = (item) => {
        setCollectionMenu(item)
    }

    const handleCollectionShow = () => {
        setCollectionMenu('collection')
    }

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.pageYOffset
            setScroll(scrollTop > 50)
        }
        window.addEventListener('scroll', handleScroll)

        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    })


  return (
    <div className=''>
        <div className='headerMain__navcontainers w-full flex justify-center items-center'>
        <section className='headerMain__navcontainer w-full lg:container mx-auto'>
          <header className="flex justify-between items-center md:gap-x-10 lg:gap-x-0 px-5 xl:px-10">
            <div>
                <div className="haodaPay__logo">
                  <img src="/images/Haodapay HD 1 (2).png" alt="img" />
                </div>
            </div>            
          </header>
        </section> 
        </div>    

    </div>

  )
}

export default Nav